export function getAnimationSpeed(
  frameCount: number,
  duration: number,
): number {
  const renderFrames = duration;
  const animationSpeed = frameCount / renderFrames;
  return Math.floor(animationSpeed * 99) / 100;
}

export function msToTicks(ms: number): number {
  return ms * 0.06;
}

// A diagonal step spans √2 cells. Stretching its duration by the same factor
// keeps pixels-per-second constant across all directions (the grid analog of
// velocity-vector normalization in free-movement games). Without it, diagonal
// movement reads as ~41% faster.
export const DIAGONAL_MOVE_FACTOR = Math.SQRT2;

export function diagonalAdjusted(
  duration: number,
  fromX: number,
  fromY: number,
  toX: number,
  toY: number,
): number {
  return fromX !== toX && fromY !== toY
    ? duration * DIAGONAL_MOVE_FACTOR
    : duration;
}
